export const PRODUCT_ONE_TIME_PAYMENT_PLAN_ID = 'ONE_TIME_ONLY';
